// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-376a2382] .app-navigation-entry__title{color:var(--color-text-maxcontrast)}`, "",{"version":3,"sources":["webpack://./src/components/NavigationAccountExpandCollapse.vue"],"names":[],"mappings":"AACA,+CACC,mCAAA","sourcesContent":["\n:deep(.app-navigation-entry__title) {\n\tcolor: var(--color-text-maxcontrast);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
